import React from 'react'
import styled from 'styled-components'
import LineIcon from '@assets/icons/line2.svg'
import SocialFacebook from '@assets/icons/facebook.svg'
import SocialInstagram from '@assets/icons/instagram.svg'
import SocialVk from '@assets/icons/vk.svg'
import SocialOk from '@assets/icons/ok.svg'
import SocialTelegram from '@assets/icons/telegram.svg'
import SocialYoutube from '@assets/icons/youtube.svg'
import { Devices } from '@styles'

type Color = 'white' | 'black'

const colors: { [key in Color]: string } = {
  black: 'rgb(51, 51, 51)',
  white: '#FFFFFF',
}

interface SocialProps {
  color?: Color
}

export const Social = (props: SocialProps) => (
  <List color={props.color}>
    <Item>
      <Link href='https://ok.ru/group/68622723514413' target='_blank'>
        <SocialOk />
      </Link>
    </Item>
    <Item>
      <Link href='https://t.me/chistovamusic' target='_blank'>
        <SocialTelegram />
      </Link>
    </Item>
    <Item>
      <Link href='https://vk.com/chistovagroup' target='_blank'>
        <SocialVk />
      </Link>
    </Item>
    <Item>
      <Link href='https://www.youtube.com/c/Chistovamusic' target='_blank'>
        <SocialYoutube />
      </Link>
    </Item>
    <Item>
      <LineIcon />
    </Item>
  </List>
)

const List = styled.ul<SocialProps>`
  display: none;
  flex-direction: column;
  align-items: center;
  position: fixed;
  bottom: 6.5%;
  left: 65px;
  z-index: 1000000;

  padding: 0;
  margin: 0;
  list-style: none;

  @media screen and ${Devices.laptop} {
    display: flex;
  }

  > li:not(:last-child) {
    margin-left: -10px;
  }

  > *:first-child {
    svg {
      > path {
        fill: ${(props) => (props.color === undefined ? colors.black : colors[props.color])};
      }
    }
  }

  > *:last-child {
    svg {
      > path,
      > circle {
        fill: ${(props) => (props.color === undefined ? colors.black : colors[props.color])};
      }
    }
  }

  > *:not(:last-child) {
    svg {
      > path,
      > circle {
        stroke: ${(props) => (props.color === undefined ? colors.black : colors[props.color])};
      }
    }
  }
`

const Item = styled.li`
  display: flex;
  font-size: 24px;
  color: #333333;
  text-transform: uppercase;
  margin-left: -5px;
  margin-bottom: 15px;

  &:last-child {
    margin-top: 15px;
  }
`

const Link = styled.a`
  color: unset;
  text-decoration: none;
`
